import React, { useEffect, useMemo, useState } from "react";
import Pagination from "react-js-pagination";
import Table from "./table";
import { useUsers } from "../../context/reducers/usersContext";
import { fetchUsers, removeUser } from "../../context/fetch/fetchUsers";
import AddModal from "./addModal";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { fetchUsersSucceed } from "../../context/actions/usersActions";
import useDebouncedSearch from "../../hooks/useDebouncedSearch";
import SearchInput from "../../core/SearchInput";
import RolesFilter from "../../core/RolesFilter";

const Main = () => {
  const [editToggle, setEditToggle] = useState(false);
  const [removeToggle, setRemoveToggle] = useState(false);

  const [activePage, setActivePage] = useState(1);
  const [offset, setOffset] = useState(0);
  const [users, dispatch] = useUsers();

  const [limit, setLimit] = useState(10);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const { searchQuery, debouncedSearch, handleSearchChange, resetSearch } = useDebouncedSearch(400);

  const initialState = useMemo(() => {
    return {
      columnName: "name",
      sortAsc: true,
    };
  }, []);
  const [sortQuery, setSortValue] = useState(initialState);

  useEffect(() => {
    setActivePage(1);
    setOffset(0);
  }, [debouncedSearch, selectedRoles]);

  useEffect(() => {
    let isCancelled = false;
    const sort = `${sortQuery.columnName}:${sortQuery.sortAsc ? "asc" : "desc"}`;

    fetchUsers(dispatch, offset, limit, sort, debouncedSearch, selectedRoles).then(
      (data) => !isCancelled && data && dispatch(fetchUsersSucceed(data))
    );
    return () => (isCancelled = true);
  }, [dispatch, offset, limit, sortQuery, debouncedSearch, selectedRoles]);

  const handlePageChange = (page) => {
    setActivePage(page);
    setOffset(limit * (page - 1));
  };

  const onPaginationSizeChange = (event) => {
    const newLimit = Number(event.target.value);
    const page = Math.ceil(users.users.count / Number(newLimit));
    if (activePage > page) {
      setActivePage(page);
    }
    setOffset(0);
    setLimit(newLimit);
  };

  return (
    <>
      <Container className={"editor-container user-manag"}>
        <Row className={"justify-content-between align-items-center mb-2"}>
          <Col className={"col-auto d-flex flex-column gap-3"}>
            <AddModal />
            <div className="d-flex gap-2">
              <h4 className={"text-uppercase editor-title mb-0"}>Users List</h4>
              {users.users.count !== undefined && (
                <span className="badge bg-primary">{users.users.count}</span>
              )}
            </div>
          </Col>
          <Col className={"col-auto d-flex gap-2"}>
            <RolesFilter selectedRoles={selectedRoles} onChange={setSelectedRoles} />
            <SearchInput
              value={searchQuery}
              onChange={handleSearchChange}
              onClear={resetSearch}
              placeholder="Search by name or email"
            />
          </Col>
        </Row>
        {users.users.users && (
          <div className="data-table-wrapper">
            <div style={{ position: "relative" }}>
              {users.users.usersLoading && (
                <div className="loader-table-wrapper">
                  <Spinner
                    animation="border"
                    variant="primary"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                    }}
                  />
                </div>
              )}
              <Table
                data={users.users.users}
                header={[
                  {
                    name: "Name",
                    prop: "name",
                    type: "text",
                    order: true,
                  },
                  {
                    name: "Email",
                    prop: "email",
                    type: "email",
                    order: false,
                  },
                  {
                    name: "Roles",
                    prop: "roles",
                    type: "roles",
                    order: false,
                  },
                ]}
                changeItem={removeUser}
                dispatch={dispatch}
                editToggle={editToggle}
                setEditToggle={setEditToggle}
                removeToggle={removeToggle}
                setRemoveToggle={setRemoveToggle}
                sortQuery={sortQuery}
                setSortValue={setSortValue}
              />
              <div className="border-top pt-5 d-flex justify-content-sm-start justify-content-center align-items-center">
                <div
                  style={{ display: users.users.usersLoading && "none" }}
                  className="d-flex align-items-center"
                >
                  <Pagination
                    innerClass="pagination"
                    itemClass="page-item"
                    linkClass="page-link"
                    hideFirstLastPages
                    pageRangeDisplayed={limit}
                    activePage={activePage}
                    itemsCountPerPage={limit}
                    totalItemsCount={users.users.count}
                    onChange={handlePageChange}
                  />
                </div>
                <div>
                  <select
                    className="pagination-options-size-changer"
                    onChange={onPaginationSizeChange}
                  >
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        )}
      </Container>
    </>
  );
};
export default Main;
